import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft } from '@elliemae/ds-icons';
import { DSBreadcrumb } from '@elliemae/ds-breadcrumb';
import { DSButtonV3, BUTTON_TYPES } from '@elliemae/ds-button-v2';
import { DSSeparator } from '@elliemae/ds-separator';
import { useSelector } from 'react-redux';
import Session, {
  APPLICATION_NAME,
  IS_LO,
} from '../../../../common/services/Session';
import { HeaderToolbar } from '../../../components/Header/HeaderMenu/HeaderTooltip';
import { HeaderTitle } from '../../../components/Header/HeaderMenu/HeaderTitle';
import { useLoanInformationField } from '../../../../data/useSelectors';
import { EnvNotificationHeader } from '../../../components/Header/EnvNotificationHeader';
import {
  ScenarioHeaderContainer,
  TopRow,
  BreadcrumbWrapper,
} from '../../../Scenario/components/ScenarioHeader/styled';
import { exitToLegacyDebug } from '../../utils';
import { DEBUG_STEPS } from './constants';

export const DebugHeader: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loanId } = useSelector(({ EPPS }: any) => EPPS?.loanPrograms || {});
  const loanIdLoanData = useLoanInformationField('loanId');
  const displayedLoanId = loanId || loanIdLoanData;
  const applicationName = Session.get(IS_LO)
    ? Session.get(APPLICATION_NAME) || 'ENCW'
    : 'EPPS';
  const isSmartClient = applicationName === 'ENC';

  const currentIndex = DEBUG_STEPS.findIndex(
    (step) => step.path === location.pathname,
  );

  // Summary is only a crumb once rate is selected.
  const summaryIndex = DEBUG_STEPS.findIndex(
    (step) => step.path === '/debug/summary',
  );
  const visibleSteps =
    summaryIndex === -1 || currentIndex === summaryIndex
      ? DEBUG_STEPS
      : DEBUG_STEPS.slice(0, summaryIndex);

  const handleBackClick = () => {
    if (currentIndex > 0) {
      navigate(DEBUG_STEPS[currentIndex - 1].path);
    } else {
      exitToLegacyDebug();
    }
  };

  const handleStepClick = (index: number) => {
    // One-directional navigation: only allow backward navigation via breadcrumb.
    // Forward navigation is handled by grid selection / footer.
    if (index < currentIndex) {
      navigate(DEBUG_STEPS[index].path);
    }
  };

  return (
    <>
      <EnvNotificationHeader />
      <ScenarioHeaderContainer>
        <TopRow>
          <BreadcrumbWrapper>
            <DSButtonV3
              buttonType={BUTTON_TYPES.ICON}
              onClick={handleBackClick}
              aria-label="Go back"
            >
              <ChevronLeft size="s" />
            </DSButtonV3>
            <HeaderTitle
              title={
                <DSBreadcrumb trailingSlash={false}>
                  {visibleSteps.map((step, index) => {
                    const isClickable = index < currentIndex;
                    return (
                      <DSBreadcrumb.Item
                        key={step.path}
                        label={step.label}
                        active={index === currentIndex}
                        {...(isClickable
                          ? { onClick: () => handleStepClick(index) }
                          : {
                              style: {
                                pointerEvents: 'none' as const,
                              },
                            })}
                      />
                    );
                  })}
                </DSBreadcrumb>
              }
            />
          </BreadcrumbWrapper>
          <HeaderToolbar
            loanId={displayedLoanId}
            isSmartClient={isSmartClient}
            handleOpenModal={exitToLegacyDebug}
          />
        </TopRow>
        <DSSeparator
          margin="s"
          orientation="horizontal"
          position="initial"
          type="non-form"
        />
      </ScenarioHeaderContainer>
    </>
  );
};

export default DebugHeader;
